const B = "/brand";

export const ASSETS = {
  logo: `${B}/logo.jpg`,
  mascot: `${B}/mascot.jpg`,
  island: `${B}/island.jpg`,
  topics: `${B}/icon_topics.jpg`,
  quiz: `${B}/icon_quiz.jpg`,
  games: `${B}/icon_games.jpg`,
  tutor: `${B}/icon_tutor.jpg`,
  progress: `${B}/icon_progress.jpg`,
  dictionary: `${B}/icon_dictionary.jpg`,
  tasks: `${B}/icon_quiz.jpg`,
};
